import { useEffect, useState } from "react";

type Props = {
  offline: React.ReactNode;
  online: React.ReactNode;
};

export default function NetworkGate({ offline, online }: Props) {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const onOnline = () => setIsOnline(true);
    const onOffline = () => setIsOnline(false);

    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);

    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  return <>{isOnline ? online : offline}</>;
}
